import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { problemRisks, problemAnswers } from '../data/problem';
import { galleryImages } from '../data/gallery';
export function ProblemSection() {
  return <section className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" data-id="element-144" data-mp="30j0r51cbs90z">
      <div className="mx-auto max-w-6xl" data-id="element-145" data-mp="2vp6euiz1uwbx">
        <SectionHeading tone="dark" size="lg" overline="La parte que nadie cuenta" title={<>
              Parece simple... hasta que las flores{' '}
              <span className="italic text-gold-200" data-id="element-147" data-mp="35g11vpk4dzyf">
                se rompen, se manchan o pierden su color
              </span>
            </>} subtitle={<>
              Prensar flores de forma bonita y duradera no depende solo de aplastarlas
              entre páginas. Hay{' '}
              <strong className="font-semibold text-cream" data-id="element-148" data-mp="1p2klfzqkp6rb">
                técnica, materiales, tiempos y cuidados
              </strong>{' '}
              que hacen toda la diferencia.
            </>} data-id="element-146" data-mp="39hmbn21cxy4e" />

        <ul className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-149" data-mp="jeoiwfu2nyqc">
          {problemRisks.map(risk => <li key={risk.title} className="flex h-full flex-col rounded-2xl border border-sage-700 bg-sage-900/60 p-5" data-id="element-150" data-mp="ocpy2podndwj">
              <AlertTriangleIcon className="h-4 w-4 text-rose-400" aria-hidden="true" data-id="element-151" data-mp="sbp5cgxkzmr5" />
              <h3 className="mt-3 font-sans text-[14px] font-semibold uppercase tracking-[0.08em] text-cream" data-id="element-152" data-mp="x5td32eo7yta">
                {risk.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-sage-200" data-id="element-153" data-mp="171wjwlkgwlmk">
                {risk.body}
              </p>
            </li>)}
        </ul>

        <div className="mt-14 grid items-center gap-8 rounded-4xl bg-cream p-6 sm:p-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12" data-id="element-154" data-mp="1bzy5pe9a2z1q">
          <img src="https://cdn.magicpatterns.com/uploads/jx3TsnMQKdi5bY9FboFDx3/MOCK_UP_DECO_FLORES.png" alt="Mockup del ebook Deco Flores — Guía Completa de Prensado y Manualidades Botánicas" className="mx-auto w-full max-w-[400px] drop-shadow-[0_30px_50px_rgba(56,52,44,0.18)]" data-id="element-155" data-mp="3dtnoa49z0v51" />
          <div data-id="element-156" data-mp="k15w87msr473">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-gold-600" data-id="element-157" data-mp="k1pczl0pnmjj">
              Lo que resuelve la guía
            </p>
            <h3 className="mt-4 font-serif text-[1.9rem] leading-[1.1] text-sage-800 sm:text-[2.3rem]" data-id="element-158" data-mp="y29yioy0fwgq">
              La diferencia entre una flor arruinada y una{' '}
              <span className="italic text-terracotta-500" data-id="element-159" data-mp="17y37jycit7tr">pieza que dura años</span>{' '}
              está en el método
            </h3>
            <ul className="mt-7 space-y-3.5" data-id="element-160" data-mp="12xxnb38kynlp">
              {problemAnswers.map(answer => <li key={answer} className="flex items-start gap-3" data-id="element-161" data-mp="1hoem0ettyzew">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-162" data-mp="1cpl6kguzgyc3">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-163" data-mp="1qqe65g056jm2" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-164" data-mp="1ls47uwj4f2w8">
                    {answer}
                  </span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-gold-200 pt-5 text-[14px] italic leading-relaxed text-ink-soft" data-id="element-165" data-mp="2abxrksnnr1gs">
              Cada tanda que sale mal son semanas de espera y materiales que ya
              compraste. La guía existe para que eso no pase desde la primera flor.
            </p>
          </div>
        </div>
      </div>
    </section>;
}